module.exports = __webpack_public_path__ + "static/atlaskit-datepicker-subtle-e789a43a8c758e25b7fd33226935856b.png";